import React from "react";

const ArchiveButton = ({ onClick, children }) => {
  return (
    <button
      className="flex border text-gray-600 hover:bg-secondary hover:text-white font-semibold py-2 px-5 rounded-md "
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ArchiveButton;
